import React  from 'react';
//前言
import zhanghaodenglu from '../assets/img/zhanghaodenglu.png';
import zhanghaodenglu1 from '../assets/img/zhanghaodenglu1.png';
import chandizhengshenqingliucheng1 from '../assets/img/chandizhengshenqingliucheng1.png';
import chandizhengshenqingliucheng2 from '../assets/img/chandizhengshenqingliucheng2.png';
import chandizhengshenqingliucheng3 from '../assets/img/chandizhengshenqingliucheng3.png';
import chandizhengshenqingliucheng4 from '../assets/img/chandizhengshenqingliucheng4.png';
import chandizhengshenqingliucheng5 from '../assets/img/chandizhengshenqingliucheng5.png';
import chandizhengshenqingliucheng6 from '../assets/img/chandizhengshenqingliucheng6.png';
import chandizhengshenqingliucheng7 from '../assets/img/chandizhengshenqingliucheng7.png';

const Enclosure618 = () => 
    <div
        style={{
            WebkitTouchCallout:'none',  /*系统默认菜单被禁用*/
            MozUserSelect: 'none',  /*火狐*/
            WebkitUserSelect: 'none',  /*webkit浏览器*/
            msUserSelect: 'none',  /*IE10*/
            khtmlUserSelect: 'none',  /*早期浏览器*/
            userSelect: 'none',
        }}
     >
        <div style={{ textIndent: '2em' }}>
            <h3>贸促会注册、产地证申领流程</h3>
            <h3>贸促会注册流程</h3>
            <h4>一、登陆 http://www.co.ccpit.org到“关于原产地证——相关表格下载”里下载《申请原产地证书企业注册登记表》，并按要求填写。</h4>
            <h4>二、按照《申请原产地证书企业注册登记表》注册需知准备相应文件及填写好的《申请原产地证书企业注册登记表》提交到申办部门（位于西直门国际商会大厦3楼）。   </h4>
            <p>1．填写完整的《申请原产地证书注册登记表》；</p>
            <p>2．企业营业执照副本及复印件一份；</p>
            <p>3．自营进出口权批件（资格证书/批准证书/备案登记表）正本及复 印件一份；</p>
            <p>4．组织机构代码证正本及复印件一份；</p>
            <p>5．企业海关注册登记证及复印件一份；</p>
            <p>6．签证机构需要的其他资料。</p>
            <h3>三、注册完毕便可获得贸促会为您提供的9位注册号</h3>
            <h4>四、打开网页：http://www.co.ccpit.org 点击注册注册成功后，企业会收到激活邮件。激活后，一般需要等一个工作日左右进行开通账号，开通后，企业就可以使用企业注册时候自行设置的账号密码登陆。</h4>   
            <img src={zhanghaodenglu} alt="" style={{ width  : '80%', display: 'block', margin : '0 auto' }}/>
            <br/>
            <img src={zhanghaodenglu1} alt="" style={{ width  : '80%', display: 'block', margin : '0 auto' }}/>
            <h4>产地证申领流程</h4>
            <h4>一、登陆贸促会原产地申报网站：http://login.qiye.ccpiteco.net/。</h4>
            <img src={chandizhengshenqingliucheng1} alt="" style={{ width  : '90%', display: 'block', margin : '0 auto' }}/>
            <br></br>
            <h4>二、点击原产地证，选择创建原产地证。根据要求选择相对应的产地证。</h4>
            <img src={chandizhengshenqingliucheng2} alt="" style={{ width  : '90%', display: 'block', margin : '0 auto' }}/>
            <br></br>
            <img src={chandizhengshenqingliucheng3} alt="" style={{ width  : '90%', display: 'block', margin : '0 auto' }}/>
            <h3>三、填写产地证内容</h3>
            <p>1.产地证内容要求与发票内容、提单内容统一</p>
            <p>2.出口方、收货方要与提单内容一致。</p>
            <p>3.运输路线需要填写起运港、卸货港、船名航次以及提单日期。</p>
            <p>4.申请地点、签署地点要填写公司所在省市。</p>
            <p>5.申请时间、签署时间填写提交当日日期。</p>
            <p>6.填写商品信息时注意事项：</p> 
            <p>6.1.税则号填写海关编码的前6位；</p>
            <p>6.2.货物描述要保持和提单货描一致；</p>
            <p>6.3.有文字唛头就填写，没有时填写N/M。不能空着。</p>
            <img src={chandizhengshenqingliucheng4} alt="" style={{ width  : '90%', display: 'block', margin : '0 auto' }}/>
            <br/>
            <p>6.4当有特殊条款时，可以在商品信息下方的特殊条款中显示。</p>
            <img src={chandizhengshenqingliucheng5} alt="" style={{ width  : '90%', display: 'block', margin : '0 auto' }}/>
            <br/>
            <img src={chandizhengshenqingliucheng6} alt="" style={{ width  : '90%', display: 'block', margin : '0 auto' }}/>
            <p>7.合同号保持与外贸合同一致，如无可以不写</p>
            <p>8.价格条款一般默认只能选择FOB</p>
            <p>9.发票金额、币种都要和发票保持一致</p>
            <p>10.付款方式根据实际选择，如是信用证付款，要在后面填写信用证号码。</p>
            <p>11.加盖商会章选择需要</p>
            <p>12.打印副本数根据需要选择</p>
            <img src={chandizhengshenqingliucheng7} alt="" style={{ width  : '90%', display: 'block', margin : '0 auto' }}/>
            <h3>四、保存并校验</h3>
            <p style={{marginLeft:'28px'}}>产地证录完后，点击保存，保存数据的同时系统会自动进行校验。如校验有误则会提出提示，请根据提示进行修改。</p>
            <h4>五、预览产地证效果</h4>
            <p style={{marginLeft:'28px'}}>成功保存后自动生成了产地证与发票，可进一步单据的内容，如果确让无误，则可发送。</p>
     
            <h3>六、发送产地证</h3>
            <p style={{marginLeft:'28px'}}>只要点击发送，则将当前产地证发送至贸促会，等待贸促会的审核。</p>
            <h3>七、单据查询----查询产地证状态</h3>
            <p style={{marginLeft:'28px'}}>得到有回执，企业端能自动收取回执，我们查看回执时进入查询\修改\打印页面，则可看到产地证的状态及处理结果，或点击刷新按钮可得到最新回执。</p>
            <p>得到回执后的状态有如下几种：</p>
            <p>新证：公司已制做，未向贸促会发证</p>
            <p>已发证：说明已合格，可以领证</p>
            <p>未通过：查看未通过原因，修改后重发。</p>
            <p>待审：等待贸促会人工审单</p>
         
            <h3>八、打印</h3>
            <p style={{marginLeft:'28px'}}>企业持商业发票、装箱单（加盖企业公章）或其它必要的文件或单证到贸促会取证，产地证书由贸促会打印。</p>
            <h3>九、改证重发的处理</h3>
            <p style={{marginLeft:'28px'}}>打开原已合格的那张证，然后点击改证重发按钮，即会增加一张同发票号的产地证，原证作为报废存档处理，对新证进行修改重新发回贸促会审核。</p>
        </div>
    </div>



export default Enclosure618;